import React, { PureComponent } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, CustomInput, Col } from "reactstrap";

class ReassignDetailsDialog extends PureComponent {
  state = {
    deassignFromPreviousClientUsers: false,
    autoAssignDevices: false,
  };

  onChange = e => {
    const { name, checked } = e.target;

    this.setState(() => ({ [name]: checked }));
  };

  accept = () => {
    const { deassignFromPreviousClientUsers, autoAssignDevices } = this.state;

    this.setState(() =>
      ({ deassignFromPreviousClientUsers: false, autoAssignDevices: false }),
      () => this.props.accept({ deassignFromPreviousClientUsers, autoAssignDevices })
    );
  };

  reject = () => {
    this.setState(() => ({ deassignFromPreviousClientUsers: false, autoAssignDevices: false }), this.props.reject);
  };

  render() {
    const { showDeassignFromPreviousClientUsersCheckbox, showAutoAssignDevicesCheckbox } = this.props;
    const { deassignFromPreviousClientUsers, autoAssignDevices } = this.state;

    return (
      <Modal isOpen={this.props.isOpen} backdrop="static" centered>
        <ModalHeader>Przypisywanie urządzeń</ModalHeader>
        <ModalBody>
          <Form>
            {showDeassignFromPreviousClientUsersCheckbox && (
              <FormGroup row>
                <Col sm={12}>
                  <CustomInput
                    type="checkbox"
                    name="deassignFromPreviousClientUsers"
                    id="deassignFromPreviousClientUsers"
                    onChange={this.onChange}
                    checked={deassignFromPreviousClientUsers}
                    label="Odpięcie przypisywanych pojazdów od użytkowników poprzedniego klienta" />
                </Col>
              </FormGroup>
            )}

            {showAutoAssignDevicesCheckbox && (
              <FormGroup row>
                <Col sm={12}>
                  <CustomInput
                    type="checkbox"
                    name="autoAssignDevices"
                    id="autoAssignDevices"
                    onChange={this.onChange}
                    checked={autoAssignDevices}
                    label="Automatyczne przypisanie urządzeń do użytkowników" />
                </Col>
              </FormGroup>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.accept}>Zapisz</Button>
          <Button color="secondary" onClick={this.reject}>Anuluj</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ReassignDetailsDialog;
